import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Row, Col, Form } from "react-bootstrap";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";

const Pagination = ({
  totalPages,
  itemsPerPage,
  handlePageClick,
  handleItemsPerPageChange,
}) => {
  const [isXs, setIsXs] = useState(
    typeof window !== "undefined" && window.innerWidth < 576
  );

  useEffect(() => {
    const handleResize = () => setIsXs(window.innerWidth < 576);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Row className="pagination-container align-items-center gy-2 px-2">
      <Col
        xs={12}
        sm="auto"
        className="d-flex align-items-center justify-content-sm-start justify-content-center gap-2"
      >
        <span className="d-none d-sm-inline">Items&nbsp;Per&nbsp;Page:</span>

        <Form.Select
          size="sm"
          className="items-select"
          value={itemsPerPage}
          onChange={handleItemsPerPageChange}
        >
          {[10, 20, 30, 40, 50, 100].map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ))}
        </Form.Select>
      </Col>

      <Col
        xs={12}
        sm
        className="d-flex justify-content-center justify-content-sm-end"
      >
        <ReactPaginate
          previousLabel={<MdArrowBackIos size={14} />}
          nextLabel={<MdArrowForwardIos size={14} />}
          breakLabel={<span className="dots">…</span>}
          pageCount={totalPages}
          marginPagesDisplayed={isXs ? 0 : 1}
          pageRangeDisplayed={isXs ? 1 : 3}
          onPageChange={handlePageClick}
          containerClassName="pagination mb-0"
          activeClassName="active"
          previousClassName="page-item"
          nextClassName="page-item"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousLinkClassName="page-link"
          nextLinkClassName="page-link"
        />
      </Col>
    </Row>
  );
};

export default Pagination;
